import { render } from "./MypageReviewList.vue?vue&type=template&id=2d82a6cf"
import script from "./MypageReviewList.vue?vue&type=script&lang=js"
export * from "./MypageReviewList.vue?vue&type=script&lang=js"

import "./MypageReviewList.vue?vue&type=style&index=0&id=2d82a6cf&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__